const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaCompassOutline0\"><g id=\"evaCompassOutline1\"><g id=\"evaCompassOutline2\" fill=\"currentColor\"><path d=\"M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8Z\"/><path d=\"M15.68 8.32a1 1 0 0 0-1.1-.25l-4.21 1.7a1 1 0 0 0-.55.55l-1.75 4.26a1 1 0 0 0 .18 1h.05A1 1 0 0 0 9 16a1 1 0 0 0 .38-.07l4.21-1.7a1 1 0 0 0 .55-.55l1.75-4.26a1 1 0 0 0-.21-1.1Zm-4.88 4.89l.71-1.74l1.69-.68l-.71 1.74Z\"/></g></g></g>"
};
exports.__esModule = true;
exports.default = data;
